import StyledLink from '../StyledLink'
import {
  CONTROLLER,
  RUNNER
} from '../routes'
import type { Props } from '../types'

const base = '/' + CONTROLLER + '/' + RUNNER

const LinkToRunner = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={base}
  >
    {children}
  </StyledLink>

export default LinkToRunner
